import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CarregandoService } from '../../services/carregando.service';
import { NotificacaoService } from '../../services/notificacao.service';
import { AtividadeService } from '../../services/atividade.service';
import { MAT_DIALOG_DATA, PageEvent, MatPaginator, MatDialogRef, MatDialog } from '@angular/material';
import { UtilitarioService } from '../../services/utilitario.service';
import { CadastroAtividadeModalComponent } from './cadastro-atividade-modal/cadastro-atividade-modal.component';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PaginatorService } from 'src/app/services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-atividade-modal',
  templateUrl: './atividade-modal.component.html',
  styleUrls: ['./atividade-modal.component.scss']
})
export class AtividadeModalComponent implements OnInit {
  atividades = [];
  idCliente;

  campoOrdenacao = 'dtPendente';
  ordenarDesc = true;
  editavel = true;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };  
  listaDeItensPorPagina = [];
  itensPorPagina = 10;

  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private atividadeService: AtividadeService,
    private utilitarioService: UtilitarioService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AtividadeModalComponent>,
    private dialog: MatDialog,
    private paginatorService: PaginatorService
  ) {
    this.idCliente = data.idCliente;

    this.buscarAtividades();
  }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarAtividades();
  }

  buscarAtividades() {
    this.carregandoService.mostra('buscaAtividades');

    this.atividadeService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.idCliente).subscribe(dados => {
      this.atividades = dados.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;

      this.carregandoService.esconde('buscaAtividades');
    }, (erro) => {
      this.carregandoService.esconde('buscaAtividades');
      this.notificacaoService.erro(erro);
    });
  }

  abrirCadastroAtividade(idAtividade?) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(CadastroAtividadeModalComponent, {
      width: largura > 950 ? '900px' : (($('body').width()).toString() + 'px'),
      data: {
        idCliente: this.idCliente,
        idAtividade: idAtividade,
      },
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.buscarAtividades();
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}